import { render, staticRenderFns } from "./TabsCard.vue?vue&type=template&id=1e46b864&scoped=true"
import script from "./TabsCard.vue?vue&type=script&lang=js"
export * from "./TabsCard.vue?vue&type=script&lang=js"
import style0 from "./TabsCard.vue?vue&type=style&index=0&id=1e46b864&prod&lang=scss&scoped=true"
import style1 from "./TabsCard.vue?vue&type=style&index=1&id=1e46b864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e46b864",
  null
  
)

export default component.exports